<template>
	<ListDetailLayout
			:store="rolesStore"
      index-route-name="admin.users.roles"
			create-permissions="create:roles"
			@on-create="disabled()"
			@on-paginate="(page) => useOnPaginate(page, refreshRoles, params)"
			@on-search="(page) => useOnSearch(page, refreshRoles, params)"
	>

		<template #list>
			<li v-for="role in rolesStore.getRoles" :key="role.id">
				<router-link :to="{ name: 'admin.users.roles.role', params: { role: role.id } }" v-slot="{isActive}">
					<div
							:class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0 flex flex-row w-full items-start justify-between">
							<div class="flex-1">
								<div class="flex items-start gap-x-3">
									<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ role.display_name }}</p>
								</div>
								<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
									<p class="whitespace-wrap">
										{{ role.description }}
									</p>
								</div>
							</div>
							<div class="text-sm text-gray-600">{{ role.permissions_count }}</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
			<router-view v-if="$route.params.role" @on-save="refreshRoles" @on-delete="refreshRoles"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useRolesStore } from "@/stores/roles.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "RolesIndex",
	data() {
		return {
			params: {
				include: ['permissionsCount'],
			}
		}
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useRolesStore)
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshRoles() {
			return this.rolesStore.indexRoles(this.params);
		},
		disabled() {
			alert('This action is disabled for data integrity and testing reasons. Please contact a developer if you need to create new roles.');
		},
	},
	async mounted() {
		await this.refreshRoles();
	},
}
</script>